// extracted by css-extract-rspack-plugin
export default {"guidancePopover":"guidancePopover-m_6K6Y","mask":"mask-o9O_mz","skip":"skip-zIZ0mn"};